// extracted by mini-css-extract-plugin
export var emailBlockLink = "_ox-0";